// extracted by css-extract-rspack-plugin
export default {"newMessageContainer":"newMessageContainer-tn8iBf","content":"content-bh051K","message":"message-X2ytQf","click":"click-Wa9vE6","close":"close-l2WAzq"};